import { cn } from '../../lib/utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const KPICard = ({ 
  title, 
  value, 
  change, 
  changeType = 'neutral', 
  icon: Icon, 
  iconBg = 'bg-blue-50', 
  iconColor = 'text-blue-600',
  className 
}) => {
  return (
    <div
      className={cn(
        'crm-card kpi-card hover-lift',
        className
      )}
      data-testid={`kpi-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between">
        {Icon && (
          <div className={cn('kpi-icon', iconBg)}>
            <Icon className={cn('w-5 h-5', iconColor)} />
          </div>
        )}
        {change && (
          <div className={cn(
            'flex items-center gap-1 text-xs font-medium',
            changeType === 'positive' ? 'text-emerald-500' : changeType === 'negative' ? 'text-red-500' : 'text-slate-500'
          )}>
            {changeType === 'positive' ? (
              <TrendingUp className="w-3.5 h-3.5" />
            ) : changeType === 'negative' ? (
              <TrendingDown className="w-3.5 h-3.5" />
            ) : null}
            {change}
          </div>
        )}
      </div>
      <div className="kpi-value">{value}</div>
      <div className="kpi-label">{title}</div>
    </div>
  );
};

export default KPICard;
